import { AntdContext } from '.'

export const useAntdContext = () => {
  const { message, notification, modalInstance } = useContext(AntdContext)

  if (!message) {
    throw new Error('message is not initialized')
  }
  if (!notification) {
    throw new Error('notification is not initialized')
  }
  if (!modalInstance) {
    throw new Error('modalInstance is not initialized')
  }

  return { message, notification, modalInstance }
}

export const useAntdCustomThemeInjected = () => {
  const { customThemeInjected } = useContext(AntdContext)

  return customThemeInjected
}
